var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeThumbnail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 152,
    viewBox: "0 0 208 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1C3.68629 1 1 3.68629 1 7V145C1 148.314 3.68629 151 7 151H201C204.314 151 207 148.314 207 145V7C207 3.68629 204.314 1 201 1H7Z",
    fill: "#F3F3F3",
    stroke: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2411 31.7539C41.2823 31.7539 39.6943 33.3419 39.6943 35.3007V35.3007C39.6943 37.2595 41.2823 38.8475 43.2411 38.8475H161.418C163.377 38.8475 164.965 37.2595 164.965 35.3007V35.3007C164.965 33.3419 163.377 31.7539 161.418 31.7539H43.2411Z",
    fill: "#E1E1E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5 32C41.567 32 40 33.567 40 35.5V35.5C40 37.433 41.567 39 43.5 39H145.193C147.126 39 148.693 37.433 148.693 35.5V35.5C148.693 33.567 147.126 32 145.193 32H43.5Z",
    fill: "#D1D1D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.379 31.7539C175.42 31.7539 173.832 33.3419 173.832 35.3007V35.3007C173.832 37.2595 175.42 38.8475 177.379 38.8475H192.476C194.435 38.8475 196.023 37.2595 196.023 35.3007V35.3007C196.023 33.3419 194.435 31.7539 192.476 31.7539H177.379Z",
    fill: "#D1D3D4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 45C27.5228 45 32 40.5228 32 35C32 29.4772 27.5228 25 22 25C16.4772 25 12 29.4772 12 35C12 40.5228 16.4772 45 22 45Z",
    fill: "#A6A8AB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8002 38.102C24.7587 38.102 24.7172 38.0606 24.6758 38.0606V38.0606C24.0533 37.8116 23.182 37.3137 23.182 36.6083C23.182 35.5294 24.4268 35.3635 24.5928 33.1643C24.7173 31.3801 23.7629 30.0938 21.9787 30.0938C20.1944 30.0938 19.2401 31.3801 19.3646 33.1643C19.5305 35.405 20.7753 35.5709 20.7753 36.6083C20.7753 37.3137 19.904 37.8116 19.2816 38.0606V38.0606C19.2401 38.0606 19.1986 38.102 19.1571 38.102C18.8251 38.268 18.5762 38.6415 18.5762 39.0564C18.5762 39.6373 19.0326 40.0937 19.6135 40.0937H21.9787H24.3438C24.9247 40.0937 25.3811 39.6373 25.3811 39.0564C25.4226 38.6415 25.1737 38.268 24.8002 38.102V38.102Z",
    fill: "#BBBDBF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2411 59.7539C41.2823 59.7539 39.6943 61.3419 39.6943 63.3007V63.3007C39.6943 65.2595 41.2823 66.8475 43.2411 66.8475H161.418C163.377 66.8475 164.965 65.2595 164.965 63.3007V63.3007C164.965 61.3419 163.377 59.7539 161.418 59.7539H43.2411Z",
    fill: "#E1E1E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5 60C41.567 60 40 61.567 40 63.5V63.5C40 65.433 41.567 67 43.5 67H64.4211C66.3541 67 67.9211 65.433 67.9211 63.5V63.5C67.9211 61.567 66.3541 60 64.4211 60H43.5Z",
    fill: "#D1D1D1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.379 59.7539C175.42 59.7539 173.832 61.3419 173.832 63.3007V63.3007C173.832 65.2595 175.42 66.8475 177.379 66.8475H192.476C194.435 66.8475 196.023 65.2595 196.023 63.3007V63.3007C196.023 61.3419 194.435 59.7539 192.476 59.7539H177.379Z",
    fill: "#D1D3D4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 73C27.5228 73 32 68.5228 32 63C32 57.4772 27.5228 53 22 53C16.4772 53 12 57.4772 12 63C12 68.5228 16.4772 73 22 73Z",
    fill: "#A6A8AB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8002 66.102C24.7587 66.102 24.7172 66.0606 24.6758 66.0606V66.0606C24.0533 65.8116 23.182 65.3137 23.182 64.6083C23.182 63.5294 24.4268 63.3635 24.5928 61.1643C24.7173 59.3801 23.7629 58.0938 21.9787 58.0938C20.1944 58.0938 19.2401 59.3801 19.3646 61.1643C19.5305 63.405 20.7753 63.5709 20.7753 64.6083C20.7753 65.3137 19.904 65.8116 19.2816 66.0606V66.0606C19.2401 66.0606 19.1986 66.102 19.1571 66.102C18.8251 66.268 18.5762 66.6415 18.5762 67.0564C18.5762 67.6373 19.0326 68.0937 19.6135 68.0937H21.9787H24.3438C24.9247 68.0937 25.3811 67.6373 25.3811 67.0564C25.4226 66.6415 25.1737 66.268 24.8002 66.102V66.102Z",
    fill: "#BBBDBF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2411 87.7539C41.2823 87.7539 39.6943 89.3419 39.6943 91.3007V91.3007C39.6943 93.2595 41.2823 94.8475 43.2411 94.8475H161.418C163.377 94.8475 164.965 93.2595 164.965 91.3007V91.3007C164.965 89.3419 163.377 87.7539 161.418 87.7539H43.2411Z",
    fill: "#E1E1E1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5 88C41.567 88 40 89.567 40 91.5V91.5C40 93.433 41.567 95 43.5 95H130.235C132.168 95 133.735 93.433 133.735 91.5V91.5C133.735 89.567 132.168 88 130.235 88H43.5Z",
    fill: "#D1D1D1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.379 87.7539C175.42 87.7539 173.832 89.3419 173.832 91.3007V91.3007C173.832 93.2595 175.42 94.8475 177.379 94.8475H192.476C194.435 94.8475 196.023 93.2595 196.023 91.3007V91.3007C196.023 89.3419 194.435 87.7539 192.476 87.7539H177.379Z",
    fill: "#D1D3D4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 101C27.5228 101 32 96.5228 32 91C32 85.4772 27.5228 81 22 81C16.4772 81 12 85.4772 12 91C12 96.5228 16.4772 101 22 101Z",
    fill: "#A6A8AB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8002 94.102C24.7587 94.102 24.7172 94.0606 24.6758 94.0606V94.0606C24.0533 93.8116 23.182 93.3137 23.182 92.6083C23.182 91.5294 24.4268 91.3635 24.5928 89.1643C24.7173 87.3801 23.7629 86.0938 21.9787 86.0938C20.1944 86.0938 19.2401 87.3801 19.3646 89.1643C19.5305 91.405 20.7753 91.5709 20.7753 92.6083C20.7753 93.3137 19.904 93.8116 19.2816 94.0606V94.0606C19.2401 94.0606 19.1986 94.102 19.1571 94.102C18.8251 94.268 18.5762 94.6415 18.5762 95.0564C18.5762 95.6373 19.0326 96.0937 19.6135 96.0937H21.9787H24.3438C24.9247 96.0937 25.3811 95.6373 25.3811 95.0564C25.4226 94.6415 25.1737 94.268 24.8002 94.102V94.102Z",
    fill: "#BBBDBF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2411 115.754C41.2823 115.754 39.6943 117.342 39.6943 119.301V119.301C39.6943 121.26 41.2823 122.848 43.2411 122.848H161.418C163.377 122.848 164.965 121.26 164.965 119.301V119.301C164.965 117.342 163.377 115.754 161.418 115.754H43.2411Z",
    fill: "#E1E1E1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5 116C41.567 116 40 117.567 40 119.5V119.5C40 121.433 41.567 123 43.5 123H118.269C120.202 123 121.769 121.433 121.769 119.5V119.5C121.769 117.567 120.202 116 118.269 116H43.5Z",
    fill: "#D1D1D1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.379 115.754C175.42 115.754 173.832 117.342 173.832 119.301V119.301C173.832 121.26 175.42 122.848 177.379 122.848H192.476C194.435 122.848 196.023 121.26 196.023 119.301V119.301C196.023 117.342 194.435 115.754 192.476 115.754H177.379Z",
    fill: "#D1D3D4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 129C27.5228 129 32 124.523 32 119C32 113.477 27.5228 109 22 109C16.4772 109 12 113.477 12 119C12 124.523 16.4772 129 22 129Z",
    fill: "#A6A8AB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8002 122.102C24.7587 122.102 24.7172 122.061 24.6758 122.061V122.061C24.0533 121.812 23.182 121.314 23.182 120.608C23.182 119.529 24.4268 119.363 24.5928 117.164C24.7173 115.38 23.7629 114.094 21.9787 114.094C20.1944 114.094 19.2401 115.38 19.3646 117.164C19.5305 119.405 20.7753 119.571 20.7753 120.608C20.7753 121.314 19.904 121.812 19.2816 122.061V122.061C19.2401 122.061 19.1986 122.102 19.1571 122.102C18.8251 122.268 18.5762 122.641 18.5762 123.056C18.5762 123.637 19.0326 124.094 19.6135 124.094H21.9787H24.3438C24.9247 124.094 25.3811 123.637 25.3811 123.056C25.4226 122.641 25.1737 122.268 24.8002 122.102V122.102Z",
    fill: "#BBBDBF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeThumbnail);
export default __webpack_public_path__ + "static/media/time-thumbnail.096cd88ac4bc3f1efb7acdc70afbaaf5.svg";
export { ForwardRef as ReactComponent };